export class InscricaoTrabalho {
    public id: number;
    public codigoInscricao: number;
    public respostaQuestionario: number;
    public alunoMatricula: number;

    //variáveis transient
    public alunoNome: string;
    public alunoRa: string;
    public categoriaTrabalho: string;
    public anoTrabalho: number;



}
